"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _react = _interopRequireDefault(require("react"));
var _educationLoans = require("@nerdwallet/marketplace/selectors/education-loans");
var _reactQuickFacts = require("@nerdwallet/react-quick-facts");
var _constants = require("../lib/constants");
var _loansQualifications = _interopRequireDefault(require("../loans-qualifications"));
var _default = function _default(_ref) {
  var bottomLine = _ref.bottomLine,
    marketplaceEntity = _ref.marketplaceEntity;
  var availableTermLengths = (0, _educationLoans.getAvailableTermLengths)(marketplaceEntity);
  var disclaimer = (0, _educationLoans.getDisclaimer)(marketplaceEntity);
  var qualifications = (0, _educationLoans.getQualificationsBullets)(marketplaceEntity);
  return {
    activeContentTab: _constants.CONTENT_TABS.KEY_FACTS,
    bottomLine: null,
    drivers: [_reactQuickFacts.mappings.educationLoans.getQuickFactFixedAPRWithAnnotation(marketplaceEntity), _reactQuickFacts.mappings.educationLoans.getQuickFactVariableAPRWithAnnotation(marketplaceEntity), _reactQuickFacts.mappings.educationLoans.getQuickFactMinCreditScore(marketplaceEntity)],
    keyFacts: bottomLine || (0, _educationLoans.getBottomLine)(marketplaceEntity),
    productDetails: !(0, _isEmpty2.default)(qualifications) || availableTermLengths || disclaimer ? /*#__PURE__*/_react.default.createElement(_loansQualifications.default, {
      bullets: qualifications,
      termLengths: availableTermLengths,
      disclaimer: disclaimer
    }) : null
  };
};
exports.default = _default;